import React, { useLayoutEffect, useState } from 'react';
import { FaArrowLeft, FaChevronRight, FaHistory, FaSeedling, FaTrash } from 'react-icons/fa';
import DentroTalhoes from './Dentro_talhoes';
import { getPlotPlantingView, plantingDetailPlot, plantingLifecycle } from './plotPlantingView';
import { resetPageScroll } from '../utils/pageScroll';
import './propriedades-platform.css';

const formatDate = value => value ? String(value).slice(0, 10).split('-').reverse().join('/') : 'Não informada';
const statusLabel = planting => ({
  active: 'Em cultivo', planned: 'Plantio planejado', harvested: 'Colhido', available: 'Registro incompleto',
})[plantingLifecycle(planting)];

export default function TalhaoPlantios({ talhao, propriedade, user, permission, initialSection, onVoltar, onCadastrar, onExcluirPlantio, darkMode }) {
  const [showHistory, setShowHistory] = useState(false);
  const [selectedPlanting, setSelectedPlanting] = useState(null);
  const { current, history, historyUnavailable } = getPlotPlantingView(talhao);
  const detail = plantingDetailPlot(talhao, selectedPlanting || current, propriedade);
  const showingDetail = talhao._operationalHistory || (detail && (selectedPlanting || (!showHistory && current)));

  useLayoutEffect(() => { resetPageScroll(); }, [showHistory, selectedPlanting?.id]);

  if (showingDetail) {
    return <>
      {!selectedPlanting && history.length > 0 && !talhao._operationalHistory && (
        <div className="props-planting-history-shortcut">
          <button type="button" className="props-plot-action is-secondary" onClick={() => setShowHistory(true)}>
            <FaHistory aria-hidden="true" /> Ver histórico de plantios ({history.length})
          </button>
        </div>
      )}
      <DentroTalhoes
        key={selectedPlanting?.id || current?.id || talhao.id}
        talhao={talhao._operationalHistory ? talhao : detail}
        user={user}
        permission={permission}
        initialSection={selectedPlanting ? null : initialSection}
        backLabel={selectedPlanting ? '← Voltar ao histórico de plantios' : undefined}
        onVoltar={selectedPlanting ? () => setSelectedPlanting(null) : onVoltar}
      />
    </>;
  }

  const records = current ? [current, ...history] : history;
  return (
    <section className={`props-detail-shell props-planting-overview ${darkMode ? 'is-dark' : ''}`} aria-label={`Plantios de ${talhao.nome}`}>
      <button type="button" className="props-back-button props-back-button-full" onClick={onVoltar}>
        <FaArrowLeft aria-hidden="true" /> Voltar para lista de talhões
      </button>
      <header className="props-planting-overview-header">
        <span>Talhão</span>
        <h2>{talhao.nome}</h2>
        <p>Área mapeada: <strong>{talhao.area ?? 'Não informada'}{talhao.area != null ? ' ha' : ''}</strong></p>
      </header>
      {!current && (
        <div className="props-planting-empty" role="status">
          <FaSeedling aria-hidden="true" />
          <h3>{records.length || historyUnavailable ? 'Sem plantio em andamento' : 'Nenhum plantio cadastrado neste talhão'}</h3>
          <p>{historyUnavailable
            ? 'Há indicação de histórico, mas os registros não estão disponíveis. Volte à lista e tente novamente.'
            : records.length
              ? 'A área está disponível para um novo plantio. Consulte os ciclos anteriores abaixo.'
              : 'Esta área ainda não possui plantio em andamento nem histórico de cultivos.'}</p>
          {onCadastrar && ['owner', 'editor'].includes(permission) && !historyUnavailable && <button type="button" className="props-plot-action is-primary" onClick={onCadastrar}>
            <FaSeedling aria-hidden="true" /> Cadastrar plantio
          </button>}
        </div>
      )}
      {records.length > 0 && (
        <section aria-label="Plantios registrados">
          <h3 className="props-planting-history-title"><FaHistory aria-hidden="true" /> {current ? 'Plantios do talhão' : 'Histórico de plantios'}</h3>
          <div className="props-planting-history-grid">
            {records.map(planting => {
              const canOpen = Boolean(plantingDetailPlot(talhao, planting, propriedade));
              return <article className="props-planting-history-card" key={planting.id}>
                <span className="props-planting-history-status">{statusLabel(planting)}</span>
                <h4>{planting.nome_legado || planting.cultura || 'Plantio'}</h4>
                <dl>
                  <div><dt>Cultura</dt><dd>{planting.cultura || 'Não informada'}</dd></div>
                  <div><dt>Plantio</dt><dd>{formatDate(planting.data_plantio)}</dd></div>
                  {planting.data_colheita && <div><dt>Colheita</dt><dd>{formatDate(planting.data_colheita)}</dd></div>}
                </dl>
                {planting.observacoes && <p>{planting.observacoes}</p>}
                <button type="button" className="props-plot-action is-secondary" disabled={!canOpen}
                  onClick={() => setSelectedPlanting(planting)}>
                  {canOpen ? 'Abrir detalhes do plantio' : 'Detalhes indisponíveis'} <FaChevronRight aria-hidden="true" />
                </button>
                {onExcluirPlantio && (
                  <button type="button" className="props-plot-action is-danger" onClick={() => onExcluirPlantio(planting)}>
                    <FaTrash aria-hidden="true" /> Excluir plantio
                  </button>
                )}
              </article>;
            })}
          </div>
        </section>
      )}
    </section>
  );
}
